import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import DirectBillPlansComponent from './DirectBillPlansComponent';
import config from '../../config';
import { carrierOptions, planRateType, incorporationState, planRule, insuranceType } from '../../utils/DropDownOptions';


const DirectBillMedicalPlans = forwardRef(({ caseId, renewalCase, isDisableForUsers, onError = () => { } }, ref) => {
    const fetchUrl = `${config.API_URL}/directBillMedicalPlans/ByCaseId/${caseId}`;
    const updateUrl = `${config.API_URL}/directBillMedicalPlans`;
    const deleteUrl = `${config.API_URL}/directBillMedicalPlans`;
    const addUrl = `${config.API_URL}/directBillMedicalPlans`;
    const planName = "Medical";



    const plansComponentRef = useRef();
    const getPlans = () => plansComponentRef.current?.getPlans();

    useImperativeHandle(ref, () => ({
        validateAll: () => plansComponentRef.current?.validateAll(),
        getPlans,
        planName,
    }));

    const formFields = [
        { name: 'carrierName', type: 'select', title: 'Carrier Name', placeholder: 'Carrier Name', tooltip: 'Carrier Name', isInclude: 'true' },
        { name: 'planName', type: 'text', title: 'Plan Name', placeholder: 'Plan Name', tooltip: 'Plan Name', isInclude: 'true' },
        { name: 'incorporationState', type: 'select', title: 'State of Plan Issuance', placeholder: 'State of Plan Issuance', tooltip: 'State of Plan Issuance', isInclude: 'true' },
        { name: 'groupNumber', type: 'text', title: 'Group Number', placeholder: 'Group Number', tooltip: 'Group Number', isInclude: 'true' },
        { name: 'subGroupNumber', type: 'text', title: 'Sub Group Number', placeholder: 'Sub Group Number', tooltip: 'Sub Group Number', isInclude: 'true' },
        { name: 'planRenewalDate', type: 'date', title: 'Plan Renewal Date', placeholder: 'Plan Renewal Date', tooltip: 'Plan Renewal Date', isInclude: 'true' },
        { name: 'insuranceType', type: 'select', title: 'Insurance Type', placeholder: 'Insurance Type', tooltip: 'Insurance Type', isInclude: 'true' },
        { name: 'planTerminationDate', isInclude: 'false' },
        { name: 'planRule', isInclude: 'false' },
        { name: 'planRateType', isInclude: 'false' },
        { name: 'currentRateStartDate', isInclude: 'false' },
        { name: 'currentRateEndDate', isInclude: 'false' },
        { name: 'futureRateStartDate', isInclude: 'false' },
        { name: 'futureRateEndDate', isInclude: 'false' }

    ];

    const selectOptions = {
        carrierName: carrierOptions,
        incorporationState: incorporationState,
        insuranceType: insuranceType,
        planRule: planRule,
        planRateType: planRateType,



    };

    return (
        <DirectBillPlansComponent
            ref={plansComponentRef}
            caseId={caseId}
            renewalCase={renewalCase}
            fetchUrl={fetchUrl}
            updateUrl={updateUrl}
            deleteUrl={deleteUrl}
            addUrl={addUrl}
            planName={planName}
            formFields={formFields}
            selectOptions={selectOptions}
            isDisableForUsers={isDisableForUsers}
            initialFormValues={{}}
        />
    );
});

export default DirectBillMedicalPlans;
